// Shared shells for the "Загальна статистика" tables. Extracted from DriverStats so the loading
// skeleton and the empty states can reuse the exact same geometry — a skeleton that doesn't match
// the real table's padding and borders reads as a layout jump when the data lands.
import styled from "styled-components";
import theme from "../../styles/theme";

export const StatsSection = styled.div`
  margin-bottom: 32px;
`;

export const StatsTablesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
  align-items: start; /* This is crucial to prevent height stretching */

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

export const StatsTable = styled.div`
  background: #2a2a2ac4;
  border: 2px solid ${theme.colors.secondaryDark};
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
  height: auto; /* Explicitly set height to auto */
  align-self: start; /* Ensure the table doesn't stretch */
`;

export const StatsTableHeader = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${theme.colors.white};
  font-family: "Montserrat", sans-serif;
  padding: 12px 16px;
  border-bottom: 2px solid ${theme.colors.secondaryDark};
`;

export const StatRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  border-bottom: 2px solid ${theme.colors.secondaryDark};

  &:last-child {
    border-bottom: none;
  }
`;

export const StatLabel = styled.div`
  font-size: 14px;
  color: ${theme.colors.white};
  font-family: "Montserrat", sans-serif;
`;

export const StatResult = styled.div`
  font-size: 14px;
  color: ${(props) => props.color || theme.colors.green};
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
`;

export const StatPercentage = styled.span`
  color: ${theme.colors.white}80; /* 50% opacity white */
  margin-left: 4px;
  font-size: 12px;
  font-weight: 400;
`;
